import type { FooterExtractor } from "../../chat/chat-tool-config";
import type { ClaimInput } from "./ClaimWidget";

/**
 * `show_claim` footer extractor — projects the claim disclaimer out of
 * the tool input into a collapsible footer item docked to the bottom of
 * the chat step. Returns `null` when the input isn't yet available, or
 * when the disclaimer is missing/blank.
 *
 * Registered in `chat/chat-tool-config.ts` under the `show_claim` entry's
 * `footerExtractor` field. Co-located with the widget so the tool-input
 * schema (`ClaimInput`) stays a single source of truth across render +
 * projection.
 */
export const extractClaimDisclaimerFooter: FooterExtractor = (messageId, partIdx, toolPart) => {
  if (toolPart.state !== "input-available" && toolPart.state !== "output-available") {
    return null;
  }
  const input = toolPart.input as Partial<ClaimInput> | undefined;
  const claim = input?.claim;
  if (!claim) return null;

  const disclaimer =
    typeof claim.disclaimer === "string" && claim.disclaimer.trim() ? claim.disclaimer : null;

  if (!disclaimer) return null;

  return {
    kind: "claim-disclaimer",
    id: `${messageId}-claim-disclaimer-${partIdx}`,
    disclaimer,
  };
};
